
export const MixinProductLabels = {
  computed: {
    productLabel() {
			if (this.product?.attributeIcon) {
				return this.themeImagePath(`attr-icon-${this.product.attributeIcon}.svg`);
			}

      return false;
    },
    productLabelText() {
			if (this.product?.attributeIcon) {
				return this.themeImagePath(`attr-${this.product.attributeIcon}.svg`);
			}

      return false;
    }
  }
};

export default MixinProductLabels;
